
import React, { useMemo } from 'react';
import classNames from 'classnames';

// Constants

import { configs } from '../../../constants/configs/configs';
import { TAGS_PAGINATION_THRESHOLD } from '../../../constants/common/miscellaneous';


const TagsList = props => {
    const {
        openTagModal,
        page,
        pushToHistory,
        tags
    } = props;

    const handleRedirection = ({ target: { dataset: { name } } }) => {
        pushToHistory(
            configs.routes.TICKET_MGMT_EXCHANGE_ASSIGNEES,
            {
                prop: 'tag',
                value: name
            }
        );
    };

    return useMemo(() => {
        return tags.reduce((tagsForRender, tag, idx) => {

            if(idx < TAGS_PAGINATION_THRESHOLD * page  || idx > TAGS_PAGINATION_THRESHOLD * (page + 1) - 1) {
                return tagsForRender;
            } else {
                const {
                    id,
                    name,
                    count
                } = tag;

                const className = classNames(
                    'desktop:grid-col-8',
                    'tag-assignees',
                    'assigned' // TODO: remove not-assigned CSS rule since we aren't going to support it
                );

                return [
                    ...tagsForRender,
                    <div key = { id } className = 'grid-row tag-info'>
                        <div className = 'desktop:grid-col-1'>
                            { idx + 1 }.
                        </div>
                        <div
                            className = 'desktop:grid-col-3 pointer tag-name'
                            onClick = { () => openTagModal(id, name) }
                        >
                            { name }
                        </div>
                        <div className = { className }>
                            <span
                                data-name = { name }
                                onClick = { handleRedirection }
                            >
                                ({ count })
                            </span>
                        </div>
                    </div>
                ];
            }
        }, [ ]);
    }, [ tags, page ]);
};

export default TagsList;